import { ClientEventEmitter } from '../../marketing/ClientEventEmitter';
import { ClientEvents } from '../../constants/clientEvents';
import { PaymentObject } from '../../types/payments';

type EventRebillBuyData = {
    payment: PaymentObject
};

export class EventRebillBuyHandler {
    public handle(data: EventRebillBuyData): void {
        ClientEventEmitter.fireEvent(ClientEvents.REBILL_BUY, { payment_object: data.payment });
    }
}
